<sv-video [posterUrl]="video.posterUrl"></sv-video>

<!--<div id="logo" class="logo-overlay" fxLayout="row" fxLayoutAlign="center center">-->
<!--  <img src="assets/ss-media-logo.png" />-->
<!--</div>-->
